import * as React from "react";
import type { SVGProps } from "react";
const SvgCrossCountrySkiing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#cross-country-skiing_svg__a)">
      <path d="M20 13c-.1 0-.21-.02-.32-.05a.99.99 0 0 1-.63-1.26l1-3c.17-.52.74-.81 1.26-.63.52.17.81.74.63 1.26l-1 3c-.14.42-.53.68-.95.68z" />
      <path d="M20 13c-.08 0-.16 0-.24-.03l-.43-.11a9 9 0 0 1-5.87-4.71l-.35-.71a.993.993 0 0 1 .45-1.34.993.993 0 0 1 1.34.45l.35.71a7 7 0 0 0 4.56 3.66l.43.11A1 1 0 0 1 20 13" />
      <path d="M6 18c-.22 0-.44-.07-.62-.22-.43-.35-.5-.97-.16-1.41l8-9.99c.35-.43.97-.5 1.41-.16.43.35.5.97.16 1.41l-8.01 10c-.2.25-.49.38-.78.38z" />
      <path d="M14 16c-.3 0-.6-.14-.8-.4l-3-4c-.33-.44-.24-1.07.2-1.4s1.07-.24 1.4.2l3 4c.33.44.24 1.07-.2 1.4-.18.13-.39.2-.6.2" />
      <path d="M12 20a1.01 1.01 0 0 1-.9-1.45l2-4c.25-.49.85-.69 1.34-.45.49.25.69.85.45 1.34l-2 4c-.18.35-.53.55-.9.55z" />
      <path d="M21 22h-1.99c-2.1 0-4.17-.31-6.18-.93L2.71 17.96a.997.997 0 0 1-.66-1.25c.16-.53.72-.82 1.25-.66l10.13 3.12c1.81.56 3.69.84 5.59.84h1.99c.55 0 1 .45 1 1s-.45 1-1 1z" />
      <path d="M17.33 21.02c-.1 0-.21-.02-.32-.05a.99.99 0 0 1-.63-1.26l1.67-5.02c.17-.52.74-.81 1.26-.63.52.17.81.74.63 1.26l-1.67 5.02c-.14.42-.53.68-.95.68zM17.68 7.42q-.375 0-.75-.12c-.6-.2-1.09-.62-1.37-1.19s-.33-1.21-.13-1.81l.23-.69a2.37 2.37 0 0 1 2.99-1.5 2.373 2.373 0 0 1 1.5 3l-.23.69c-.33.99-1.25 1.62-2.25 1.62zM17.91 4c-.15 0-.3.1-.35.25l-.23.69c-.04.12 0 .23.02.28s.09.14.21.18c.2.06.4-.04.46-.23l.23-.69c.04-.12 0-.23-.02-.28a.35.35 0 0 0-.21-.18S17.94 4 17.91 4" />
    </g>
    <defs>
      <clipPath id="cross-country-skiing_svg__a">
        <path fill="#fff" d="M2 2h20v20H2z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCrossCountrySkiing;
